import classNames from 'classnames';
import React from 'react';
import styles from './row.module.scss';

export type RowProps = React.HTMLAttributes<HTMLDivElement>;

const Row = ({ children, className, ...rest }: RowProps) => {
  return (
    <div {...rest} className={classNames(styles.component, className)}>
      {children}
    </div>
  );
};

export default Row;
